module.exports = __webpack_public_path__ + "img/signing.3e769dc3.svg";